import React from 'react';
import { Cancel, CheckCircle, HourglassEmpty, ThumbDown, WatchLater } from '@material-ui/icons';
import { useGenericStyles } from 'common/genericStyles';
import { Grid, Typography } from '@material-ui/core';

const LegendaStatusEventos: React.FC = () => {
  const classes = useGenericStyles();

  return (
    <Grid container justifyContent="flex-start" spacing={4}>
      <Grid item style={{ display: 'inline-flex', alignItems: 'center' }}>
        <WatchLater fontSize="small" className={classes.warningIcon} />
        <Typography display="inline">{'Previsto / Aguardando liquidação'}</Typography>
      </Grid>
      <Grid item style={{ display: 'inline-flex', alignItems: 'center' }}>
        <HourglassEmpty fontSize="small" className={classes.waitingIcon} />
        <Typography display="inline">{'Pendente de aprovação A.F.'}</Typography>
      </Grid>
      <Grid item style={{ display: 'inline-flex', alignItems: 'center' }}>
        <CheckCircle fontSize="small" className={classes.successIcon} />
        <Typography display="inline">{'Concluída'}</Typography>
      </Grid>
      <Grid item style={{ display: 'inline-flex', alignItems: 'center' }}>
        <CheckCircle fontSize="small" className={classes.warningIcon} />
        <Typography display="inline">{'Parcialmente Concluída'}</Typography>
      </Grid>
      <Grid item style={{ display: 'inline-flex', alignItems: 'center' }}>
        <ThumbDown fontSize="small" className={classes.errorIcon} />
        <Typography display="inline">{'Reprovado pelo A.F.'}</Typography>
      </Grid>
      <Grid item style={{ display: 'inline-flex', alignItems: 'center' }}>
        <Cancel fontSize="small" className={classes.errorIcon} />
        <Typography display="inline">{'Cancelada / Reprovada'}</Typography>
      </Grid>
    </Grid>
  );
};

export default LegendaStatusEventos;
